import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e23cf47"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "text-right"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading w-8 h-8" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "vaults-detail-actions-main"
}
const _hoisted_5 = { class: "vaults-detail-actions-link" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "vaults-detail-actions-button" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "text-sssm lg:text-sm" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "text-3xs lg:text-xs" }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "flex justify-end" }
const _hoisted_16 = { class: "flex justify-end" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "flex justify-between mt-2" }
const _hoisted_19 = { class: "text-2xs lg:text-xs font-light italic" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "mt-2 text-2xs lg:text-xs font-light italic" }
const _hoisted_22 = {
  key: 0,
  class: "loading h-3 w-3 ml-2"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 0,
  class: "flex items-center text-red-520 mt-1"
}
const _hoisted_25 = { class: "text-xs lg:text-sssm" }
const _hoisted_26 = { class: "text-right" }
const _hoisted_27 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_28 = { class: "ml-1 lg:ml-2 text-sssm lg:text-sm font-medium" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 2,
  class: "text-right text-sssm lg:text-sm"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "underline text-blue-930",
  href: "https://docs.acryptos.com/acryptos-vaults/liquidizer-vaults",
  target: "_blank"
}, "Liquidizer Vault", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")!
  const _component_BalTooltipV2 = _resolveComponent("BalTooltipV2")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalToggle = _resolveComponent("BalToggle")!

  return (_ctx.status === 'loading')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (!_ctx.status)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("a", {
              class: "vaults-detail-actions-link-item",
              target: "_blank",
              href: 
          _ctx.explorerLinks.addressLink(
            _ctx.farmVault.vault ? _ctx.farmVault.vault.address : _ctx.farmVault.farm.master
          )
        
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('view_contract')) + " ", 1),
              _createVNode(_component_BalIcon, {
                class: "ml-0.5 lg:ml-1",
                name: "ei:external-link",
                size: _ctx.upToLargeBreakpoint ? 'xs' : 'smd'
              }, null, 8, ["size"])
            ], 8, _hoisted_6),
            _createElementVNode("a", {
              class: "vaults-detail-actions-link-item",
              target: "_blank",
              href: 
          _ctx.farmVault.vault?.isLiquid
            ? 'https://docs.acryptos.com/acryptos-vaults/liquidizer-vaults'
            : 'https://docs.acryptos.com/security-and-risks#aprs-returns'
        
            }, [
              _createTextVNode(_toDisplayString(_ctx.$t('risk_warning')) + " ", 1),
              _createVNode(_component_BalIcon, {
                class: "ml-0.5 lg:ml-1",
                name: "ei:external-link",
                size: _ctx.upToLargeBreakpoint ? 'xs' : 'smd'
              }, null, 8, ["size"])
            ], 8, _hoisted_7)
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.farmVault.vault?.warning)
              ? (_openBlock(), _createBlock(_component_BalTooltipV2, {
                  key: 0,
                  width: "64",
                  trigger: "click",
                  placement: "left"
                }, {
                  activator: _withCtx(() => [
                    _createVNode(_component_BalIcon, {
                      name: "ant-design:warning-filled",
                      class: "text-red-520"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "text-sm w-64",
                      innerHTML: _ctx.farmVault.vault?.warning
                    }, null, 8, _hoisted_9)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.farmVault.vault?.additionalInfo)
              ? (_openBlock(), _createBlock(_component_BalTooltipV2, {
                  key: 1,
                  width: "64",
                  trigger: "click",
                  placement: "left"
                }, {
                  activator: _withCtx(() => [
                    _createVNode(_component_BalIcon, {
                      name: "ant-design:warning-filled",
                      class: "text-white-520"
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "text-sm w-64",
                      innerHTML: _ctx.farmVault.vault?.additionalInfo
                    }, null, 8, _hoisted_10)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.walletInfoList, (item, index) => {
              return (_openBlock(), _createBlock(_component_BalBtn, {
                rounded: "",
                color: "amber",
                size: "sm",
                class: "vaults-detail-actions-button-token",
                key: index,
                onClick: ($event: any) => (_ctx.goTo(item.link))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.label), 1),
                    _hoisted_12,
                    _createElementVNode("span", _hoisted_13, _toDisplayString(item.sublabel), 1)
                  ])
                ]),
                _: 2
              }, 1032, ["onClick"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleButtonList, (item, index) => {
              return (_openBlock(), _createBlock(_component_BalBtn, {
                key: index,
                outline: item.name === 'harvest_to_vault',
                rounded: "",
                color: "amber",
                size: "sm",
                class: "w-28 lg:w-36 ml-2 mt-2",
                onClick: ($event: any) => (_ctx.gotoStatus(item.name))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.name === 'withdraw' ? _ctx.$t('withdraw.label') : _ctx.$t(item.name)), 1)
                ]),
                _: 2
              }, 1032, ["outline", "onClick"]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            (_ctx.upToLargeBreakpoint && !_ctx.status.startsWith('harvest'))
              ? (_openBlock(), _createBlock(_component_BalBtn, {
                  key: 0,
                  outline: "",
                  rounded: "",
                  color: "amber",
                  size: "sm",
                  class: "w-32 mb-2",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.init()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.status !== 'harvest')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.amount) = $event)),
                    class: "action-input"
                  }, null, 512), [
                    [_vModelText, _ctx.amount]
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('balance')) + ": " + _toDisplayString(_ctx.getBalance()), 1),
                    _createElementVNode("a", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getMax && _ctx.getMax(...args))),
                      class: "underline italic text-2xs lg:text-xs float-right mr-2"
                    }, _toDisplayString(_ctx.$t('max').toLowerCase()), 1)
                  ]),
                  (
            _ctx.status === 'withdraw' && _ctx.farmVault?.vault.isLiquid && _ctx.amount !== ''
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("p", _hoisted_21, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('receive')) + ": ", 1),
                          (_ctx.isGettingCalculatedWithdraw)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_22))
                            : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.farmVault?.vault?.stats.value.calculatedWithdraw
                ? `${_ctx.showTokenBalance(
                    _ctx.farmVault?.vault?.stats.value.calculatedWithdraw
                  )} (${_ctx.compact}%)`
                : ''), 1))
                        ]),
                        (_ctx.compact < -5)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                              _createVNode(_component_BalIcon, {
                                name: "akar-icons:info",
                                size: "xs"
                              }),
                              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('price_impact_too_high')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_BalBtn, {
                rounded: "",
                disabled: _ctx.disableAction,
                color: "amber",
                size: "sm",
                class: "w-32 lg:w-36 ml-2 mb-2",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doAction(_ctx.status)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(_ctx.status)), 1)
                ]),
                _: 1
              }, 8, ["disabled"]),
              (!_ctx.upToLargeBreakpoint || _ctx.status.startsWith('harvest'))
                ? (_openBlock(), _createBlock(_component_BalBtn, {
                    key: 0,
                    outline: "",
                    rounded: "",
                    color: "amber",
                    size: "sm",
                    class: "w-32 lg:w-36 ml-2 mb-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.init()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
            _ctx.farmVault.farm && (_ctx.status === 'unstake' || _ctx.status === 'deposit')
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createVNode(_component_BalToggle, {
                      initValue: _ctx.isAll,
                      onOnChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isAll = !_ctx.isAll)),
                      size: "sm",
                      class: "ml-auto"
                    }, null, 8, ["initValue"]),
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.status === 'unstake'
                ? _ctx.$t('and_withdraw_all')
                : _ctx.$t('and_stake_all')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.status === 'stake' || _ctx.status === 'harvest' || _ctx.status === 'unstake')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "transaction-info",
                innerHTML: _ctx.farmVault.farmTransactionInfo || _ctx.defaultFarmTransactionInfo
              }, null, 8, _hoisted_29))
            : _createCommentVNode("", true),
          (_ctx.status === 'deposit' || _ctx.status === 'withdraw')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "transaction-info",
                innerHTML: _ctx.farmVault.vaultTransactionInfo || _ctx.defaultVaultTransactionInfo
              }, null, 8, _hoisted_30))
            : _createCommentVNode("", true),
          (
        (_ctx.status === 'deposit' || _ctx.status === 'withdraw') &&
        _ctx.farmVault?.vault?.isLiquid
      )
            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                _createTextVNode(" This is a "),
                _hoisted_32,
                _createTextVNode(" and you may experience significant slippage and limits when withdrawing. ")
              ]))
            : _createCommentVNode("", true)
        ]))
}